/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Maya(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.42011 1.70327H20.3177C20.9277 1.73446 21.5486 2.17442 21.5829 2.82027C21.6204 3.72201 21.5814 4.62695 21.5954 5.53022C21.6048 9.86418 21.597 14.1982 21.6001 18.5307C16.6249 18.5354 11.6497 18.5275 6.6745 18.5369C5.92721 18.5572 5.17831 18.5946 4.43101 18.5307C4.392 12.9298 4.41382 7.32901 4.41856 1.72817L4.42011 1.70327Z"
        fill="#39A5CC"
      />
      <path
        d="M8.25226 5.25C9.24031 5.25258 10.2284 5.25 11.2171 5.25129C11.8476 7.74332 12.4608 10.2399 13.0991 12.73C13.7613 10.2386 14.4202 7.7459 15.072 5.25129C16.0304 5.25515 16.9895 5.24291 17.9479 5.25773C17.9383 8.38485 17.9473 11.512 17.9434 14.6391C17.1976 14.6391 16.4517 14.6397 15.7058 14.6384C15.7032 12.6552 15.7097 10.6714 15.7032 8.68758C15.1686 10.6695 14.6604 12.6585 14.131 14.641C13.3961 14.6365 12.6605 14.6404 11.9256 14.6391C11.371 12.5683 10.8499 10.4872 10.2792 8.42092C10.2792 10.4936 10.2799 12.5664 10.2792 14.6391C9.60294 14.6391 8.92663 14.6391 8.25032 14.6391C8.25161 11.5094 8.24775 8.37969 8.25226 5.25Z"
        fill="white"
      />
      <path
        d="M0.75 3.94679C1.95907 3.18544 3.19156 2.46003 4.41943 1.72826C4.41468 7.3291 4.39287 12.9299 4.43188 18.5308C3.86712 18.8646 3.30859 19.2094 2.7423 19.5433C2.0761 19.9411 1.41773 20.3499 0.75 20.7461V3.94679Z"
        fill="#7FC5DE"
      />
      <path
        d="M21.5964 5.53029C22.1472 5.52561 22.6994 5.52561 23.2501 5.52407C23.2377 11.1155 23.2486 16.7054 23.2439 22.2969H3.87036C3.36643 22.2189 2.87347 21.8834 2.77203 21.3593C2.67534 20.7587 2.74553 20.1471 2.74239 19.5433C3.30875 19.2094 3.86728 18.8646 4.43203 18.5308C5.17933 18.5947 5.92816 18.5573 6.67546 18.537C11.6507 18.5276 16.6259 18.5354 21.6011 18.5308C21.598 14.1983 21.6058 9.86431 21.5964 5.53029Z"
        fill="#36687F"
      />
    </svg>
  )
}

Maya.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Maya
